import React, { useEffect, useRef, useState } from "react";
import Header from "./components/Header";
import Hero from "./components/Hero";
import Features from "./components/Features";
import ScienceBack from "./components/ScienceBack";
import Pricing from "./components/Pricing";
import GuranteeLicence from "./components/GuranteeLicence";
import FAQs from "./components/FAQs";
import PricingCards from "./components/vsl/pricing";
import Gurantee from "./components/vsl/gurantee";
import Bonuses from "./components/vsl/Bonuses";
import Contact from "./components/vsl/Contact";
import Testimonials from "../../components/testomonials";
import FAQ from "./components/vsl/Faq";
import Footer from "./components/Footer";
import { useLocation } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import WhyOrder from "./components/vsl/whyOrder";
import ClinicalStudies from "../../components/Studies";
import TherapistInfo from "./components/vsl/TherapistInfo";
import arrow from "../../assets/blue-arrow.webp";
import { LOADER_STATUS } from "../../constant/data";

const V2 = () => {
  const [isShowVsl, setIsShowVsl] = useState(-1);
  const [isVisible, setIsVisible] = useState(false);
  const [isVideoParamExists, setIsVideoParamExists] = useState(null);
  const location = useLocation();
  const pricingRef = useRef(null);






  const [startTimer, setStartTimer] = useState(false);
  const [isVideoPlay, setIsVideoPlay] = useState(null);

  useEffect(() => {
    if (isShowVsl === -1 && location) {
      setIsShowVsl(0);
      const { search } = location;
      const params = new URLSearchParams(search);

      const hasAnyParam = Array.from(params.entries()).length > 0;

      setIsVideoParamExists(hasAnyParam);

      setIsShowVsl(1);
    }
  }, [location]);







  const maximizeVideo = () => {
    setIsVideoPlay(LOADER_STATUS.PLAY);

    // console.log("Maximize Video", "LOADER", isVideoPlay);
    setIsVideoPlay(LOADER_STATUS.PLAY);
    const video = document.querySelector("#smartplayer");
    const vidwrapper = document.querySelector("#smartplayer > div");
    const vidwrappervid = document.querySelector(
      "#smartplayer > div > div.smartplayer-video-wrap > video"
    );

    video.style.maxWidth = "100%";
    video.style.height = "100vh";
    video.style.padding = "0px";
    video.style.backgroundColor = "#000";

    vidwrapper.style.height = "100vh";
    vidwrapper.style.width = "100%";
    vidwrappervid.style.height = "100vh";
    vidwrappervid.style.width = "100%";
    vidwrappervid.style.objectFit = "contain";

    vidwrappervid.style.transform = "scale(1)";
    vidwrappervid.style.transformOrigin = "top left";

    if (window.innerWidth < 700) {
      vidwrappervid.style.objectFit = "contain";
    }
  };

  const minimizeVideo = () => {
    // console.log("Minimize Video");
    const video = document.querySelector("#smartplayer");
    const vidwrapper = document.querySelector("#smartplayer > div");
    const vidwrappervid = document.querySelector(
      "#smartplayer > div > div.smartplayer-video-wrap > video"
    );

    video.style.padding = "20px";
    video.style.maxWidth = "900px";
    video.style.height = "480px";
    video.style.backgroundColor = "transparent";

    vidwrapper.style.height = "100%";
    vidwrapper.style.width = "100%";

    vidwrappervid.style.height = "100%";
    vidwrappervid.style.width = "100%";
    vidwrappervid.style.objectFit = "cover";

    vidwrappervid.style.transform = "scale(1)";
    vidwrappervid.style.transformOrigin = "top left";

    if (window.innerWidth < 700) {
      vidwrappervid.style.objectFit = "cover";
    }
  };

  useEffect(() => {
    const SECONDS_TO_DISPLAY = 1866;
    let attempts = 0;
    let elsDisplayed = false;

    const alreadyDisplayedKey = `alreadyElsDisplayed${SECONDS_TO_DISPLAY}`;
    const alreadyElsDisplayed = localStorage.getItem(alreadyDisplayedKey);

    const showHiddenElements = () => {
      elsDisplayed = true;
      setIsVisible(true);
      localStorage.setItem(alreadyDisplayedKey, true);

      const player = window.smartplayer.instances?.[0];
      const currentTime = player?.video?.currentTime;
      // console.log(`CTA dropped at Current video time: ${currentTime}`);
    };

    const startWatchVideoProgress = () => {
      if (
        typeof window.smartplayer === "undefined" ||
        !(window.smartplayer.instances && window.smartplayer.instances.length)
      ) {
        if (attempts >= 10) return;
        attempts += 1;
        return setTimeout(() => {
          startWatchVideoProgress();
        }, 1000);
      }
      const player = window.smartplayer.instances[0];
      player.on("timeupdate", () => {
        if (player.smartAutoPlay === false) {
          setIsVideoPlay(LOADER_STATUS.PLAY);
          maximizeVideo();
        }

        if (elsDisplayed || player.smartAutoPlay) return;
        const currentTime = player.video.currentTime;
        // console.log("Current video time:", currentTime);

        if (player.video.currentTime < SECONDS_TO_DISPLAY) return;
        showHiddenElements();
      });

      player.on("pause", () => {
        setIsVideoPlay(LOADER_STATUS.PAUSE);
        minimizeVideo();
      });

      //   player.options.autoplay = false;
      // player.smartAutoPlay = false;
    };

    if (alreadyElsDisplayed === "true") {
      setTimeout(() => {
        showHiddenElements();
      }, 100);
    } else {
      startWatchVideoProgress();
    }
  }, []);

  useEffect(() => {
    if (isVisible && pricingRef.current) {
      pricingRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }, [isVisible]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) setIsVisible(true);
      },
      { threshold: 0.1 }
    );

    if (pricingRef.current) observer.observe(pricingRef.current);

    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    if (isVisible && !startTimer) {
      setStartTimer(true);
    }
  }, [isVisible, startTimer]);

  const [vid, setVid] = useState("");

  useEffect(() => {
    function replaceVidPlaceholder() {
      if (window?.clickmagick_cmc?.vid) {
        setVid(window.clickmagick_cmc.vid);
      } else {
        setTimeout(replaceVidPlaceholder, 200);
      }
    }
    replaceVidPlaceholder();
  }, []);

  const skipVideoAndShowCTA = () => {
    const video = document.querySelector('video');
    if (video) {
      video.currentTime = 1866;
      video.dispatchEvent(new Event('timeupdate'));
    }
    setIsVisible(true);
  };

  return (
    <>
      <Helmet >

<meta name="description" content="dynamic script v2 page" />

  {/* <script>
    {`
    (function (w, d, s, l, i) {
      w[l] = w[l] || []; 
      w[l].push({
        'gtm.start': new Date().getTime(), event: 'gtm.js'
      }); 
      var f = d.getElementsByTagName(s)[0],
        j = d.createElement(s), 
        dl = l != 'dataLayer' ? '&l=' + l : ''; 
      j.async = true; 
      j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl; 
      f.parentNode.insertBefore(j, f);
    })(window, document, 'script', 'dataLayer', 'GTM-TT5DJ9PL');
  `}
  </script>

  <script>
    {`
    !function (f, b, e, v, n, t, s) {
      if (f.fbq) return; 
      n = f.fbq = function () {
        n.callMethod ?
        n.callMethod.apply(n, arguments) : n.queue.push(arguments)
      };
      if (!f._fbq) f._fbq = n; 
      n.push = n; 
      n.loaded = !0; 
      n.version = '2.0'; 
      n.queue = []; 
      t = b.createElement(e); 
      t.async = !0;
      t.src = v; 
      s = b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t, s)
    }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    fbq('init', '392391338791946');
    fbq('track', 'PageView');
  `}
  </script>

  <noscript>
    {`<img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=392391338791946&ev=PageView&noscript=1" alt="" />`}
  </noscript>

  <script>
    {`
    window.cmcConfig = {
      "edcf84gknlfe38bnh1u-x76f-p": {
        uid: '161365',
        hid: '2676846489',
        cmc_project: 'Respoclear',
        vid_info: 'on',
        utm_source: 'organic',
      },
      "a1revenue": {
        uid: '161365',
        hid: '2676846489',
        cmc_project: 'Respoclear',
        vid_info: 'on', 
        utm_source: 'organic',
      }
    };

    var match = RegExp('[?&]shield=([^&]*)').exec(window.location.search) || RegExp('[?&]affiliate=([^&]*)').exec(window.location.search);
    var affiliate = match && decodeURIComponent(match[1].replace(/\\+/g, ' '));
    window.clickmagick_cmc = window.cmcConfig[affiliate];
  `}
  </script>
  <script src="//cdn.clkmc.com/cmc.js"></script>

  <script>
    {`
    window.clickbank = {
      vendor: "scalerespo",
      tid: clickmagick_cmc && clickmagick_cmc.vid
    }
  `}
  </script>
  <script src="https://scripts.clickbank.net/hop.min.js" defer></script>

  <script async type="text/javascript">
    {`
    window.visiopt_code = window.visiopt_code || (function(){
      var visi_wid = 979,
          visi_pid = 91,
          visi_flicker_time = 4000,
          visi_flicker_element = 'html',
          c = false,
          d = document,
          visi_fn = {
            begin: function(){
              var a = d.getElementById('visi_flicker');
              if (!a) {
                var a = d.createElement('style'),
                    b = visi_flicker_element ? visi_flicker_element + '{opacity:0!important;background:none!important;}' : '',
                    h = d.getElementsByTagName('head')[0];
                a.setAttribute('id', 'visi_flicker');
                a.setAttribute('type', 'text/css');
                if (a.styleSheet) {
                  a.styleSheet.cssText = b;
                } else {
                  a.appendChild(d.createTextNode(b));
                }
                h.appendChild(a);
              }
            },
            complete: function(){
              c = true;
              var a = d.getElementById('visi_flicker');
              if (a) {
                a.parentNode.removeChild(a);
              }
            },
            completed: function(){
              return c;
            },
            pack: function(a){
              var b = d.createElement('script');
              b.src = a;
              b.type = 'text/javascript';
              b.innerText;
              b.onerror = function(){
                visi_fn.complete();
              };
              d.getElementsByTagName('head')[0].appendChild(b);
            },
            init: function(){
              visi_fn.begin();
              setTimeout(function(){
                visi_fn.complete();
              }, visi_flicker_time);
              this.pack('https://visiopt.com/client/js_test/test.' + visi_wid + '.' + visi_pid + '.js');
              return true;
            }
          };
      window.visiopt_code_status = visi_fn.init();
      return visi_fn;
    })();
  `}
  </script> */}
</Helmet>
      {isVideoParamExists !== null && (
        <div className="w-full">
          {isVideoParamExists ? (
            <>
              {/* vsl page */}
              <div
                className={
                  isVideoPlay === LOADER_STATUS.PLAY
                    ? "w-full"
                    : "max-w-7xl mx-auto"
                }
              >
                {/* Top Block */}
                <div
                  className={
                    isVideoPlay === LOADER_STATUS.PLAY
                      ? "hidden"
                      : "p-3 pt-6 space-y-3 max-w-7xl text-center flex flex-col items-center justify-center"
                  }
                >
                  <h3 className="text-[27px]  text-black font-bold warning">
                    Top US Pulmonologist:
                  </h3>

                  <h3 className="lg:text-4xl lg:leading-[48px] md:text-3xl text-2xl max-w-4xl text-[#dc252c] font-bold ">
                    "This Daily Habit That Clears Mucus & Promotes Easy Lung Function!"
                    {/* a  */}
                  </h3>
                </div>

                {/* Dynamically embed the player script */}
                <div className="w-full flex items-center justify-center">
  <div
    className={
      isVideoPlay === LOADER_STATUS.PLAY
        ? "w-full"
        : "md:w-[70%] w-[90%]"
    }
    dangerouslySetInnerHTML={{
      __html: `<script type="text/javascript" id="scr_67faa38fd54c3c8ca1d8b182"></script>`,
    }}
  />

  {/* Helmet to inject the video player script into the head */}
  <Helmet>
    <script type="text/javascript">
      {`
        var s = document.createElement("script");
        s.src = "https://scripts.converteai.net/10a8aace-0f8a-44a8-a764-4b0ebbd85e70/players/67faa38fd54c3c8ca1d8b182/player.js";
        s.async = true;
        document.head.appendChild(s);
      `}
    </script>
  </Helmet>
</div>

                

                <div
                  id="smartplayer"
                  style={{
                    width: "100%",
                    position: "relative",
                    padding: "0",
                  }}
                ></div>

                {/* <div className="text-center mt-10">
                  <button
                    onClick={skipVideoAndShowCTA}
                    className="px-6 py-3 bg-blue-500 text-white rounded-full"
                  >
                    Skip Video and Show CTA
                  </button>
                </div> */}

                <div className="flex items-center justify-center gap-2 mt-14 mb-5 md:mb-0 max-w-7xl mx-auto text-center">
                  <img
                    src="https://cdn1.breatheagain.io/media/vsl/charm_sound.svg"
                    width="28"
                    height="28"
                    className="md:block hidden"
                  />
                  <p className="text-lg sm:text-xl font-semibold leading-6 text-black">
                    <span className="text-red-600 font-bold">IMPORTANT:</span>{" "}
                    Your video may take 10 seconds to load. Make sure your sound
                    is on.
                  </p>
                </div>
              </div>
              {isVisible && (
                <div
                  className="hide smartplayer-scroll-event"
                  id="hidden-section"
                >
                  <div className="md:block hidden ">
                    <div className="max-w-7xl mx-auto my-4 flex items-center justify-center ">
                      <img
                        src="https://cdn.blackincae.com/z8A-blue-arrow.png"
                        className="w-10 h-16"
                      />
                    </div>
                  </div>

                  <div ref={pricingRef}>
                    <PricingCards startTimer={startTimer} />
                  </div>
                  <WhyOrder />
                  <Gurantee />
                  <Bonuses />
                  <Contact />
                  <Testimonials />
                  <PricingCards startTimer={startTimer} />
                  <FAQ />
                </div>
              )}
              <TherapistInfo />
              <ClinicalStudies
                onClickSkip={skipVideoAndShowCTA}
              />
            </>
          ) : (
            <div className="min-h-screen bg-navy-900">
              <Header />
              <Hero />
              <Features />
              <ScienceBack />
              <Pricing />
              <GuranteeLicence />
              <FAQs />
              <Pricing />
              <Footer />
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default V2;